import { get } from '../axios';

const API_PREFIX = '/shopInfo';

function buildPaketeByVertragUrl(vertragsId, isAdmin = false) {
  const adminPath = isAdmin ? '/admin' : '';

  return `${API_PREFIX}/paketeByVertrag/${vertragsId}${adminPath}`;
}

export default {
  /**
   * Receive packages that include a contract
   *
   * @param {string} vertragsId
   */
  fetchPaketeByVertrag(vertragsId) {
    return get(buildPaketeByVertragUrl(vertragsId));
  },

  /**
   * Receive packages that include a contract for admin flow
   *
   * @param {string} vertragsId
   */
  fetchPaketeByVertragAdmin(vertragsId) {
    return get(buildPaketeByVertragUrl(vertragsId, true));
  },
};
